import { render, staticRenderFns } from "./EditExerciseAudioText.vue?vue&type=template&id=95aa1fa2&"
import script from "./EditExerciseAudioText.vue?vue&type=script&lang=ts&"
export * from "./EditExerciseAudioText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports